const STORAGE_KEY = "noki_encounter_owners";

const readOwnerMap = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

// Persists which user started a given encounter's conversation so ownership
// survives a page reload in the same browser (Redux state resets on reload).
export const persistEncounterOwner = (encounterId, ownerUid) => {
  if (!encounterId || !ownerUid) return;
  const map = readOwnerMap();
  map[encounterId] = ownerUid;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
};

export const getPersistedEncounterOwner = (encounterId) => {
  if (!encounterId) return null;
  return readOwnerMap()[encounterId] || null;
};
